import algoliasearch from 'algoliasearch';

var createClient = function createClient() {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2;

  return algoliasearch((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "", (_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "");
};

export { createClient };